import { defineStore } from 'pinia'
import { checkStudentAuthData, getGroupById, getAllStudentMessages, getStudentCompletedTrainings, getStudentBodyParametersRequest, getTrainerById, getStudentsByGroupId, getPlanedTrainingsByGroupId, getIncomesByBalanceId, getBalanceState, updateStudentPersonalDataAgreementsRequest, updateSchoolRulesAgreementsRequest, checkBotSubscribe } from '../services/apiRequests'

export const useMainStore = defineStore('main', {
    state: () => ({
        student: {},
        group: {},
        trainer: {},
        planedTrainingsData: [],
        studentIncomes: [],
        studentBalance: 0,
        isBotSubscribed: false,
        groupStudents: [],
        studentMessages: [],
        studentsHeights: [],
        studentsWeights: [],
        studentAttendedTrainings: [],
        studentMissedTrainings: []
    }),
    
    getters: {
        studentAge: (state) => new Date().getFullYear() - new Date(state.student.birthday).getFullYear(),
        trainerName: (state) => `${state.trainer.name} ${state.trainer.surname}`,
        studentName: (state) => `${state.student.name} ${state.student.surname}`,
        mappedDatesPlanningTrainings: (state) => state.planedTrainingsData.map(training => new Date(training.date).toISOString().split('T')[0]),
        studentPhoto: (state) => process.env.VUE_APP_API_URL + 'static/' + state.student.photo,
        trainingsAttendedProcent: (state) => state.studentAttendedTrainings.length * 100 / (state.studentAttendedTrainings.length + state.studentMissedTrainings.length),
        startTrainingDate: (state) => state.student.start_training?.split('T')[0].replaceAll('-', '.'),
        passportEndDate: (state) => state.student.passport_end_date?.split('T')[0].replaceAll('-', '.'),
        attendedTrainingsPercent: (state) => state.studentAttendedTrainings.length * 100 / (state.studentAttendedTrainings.length + state.studentMissedTrainings.length) 
    },
    
    actions: {
        async readFileAsDataURL(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.onload = (e) => resolve(e.target.result)
                reader.onerror = (e) => reject(e)
                reader.readAsDataURL(file)
            })
        },
        async getStudentMessages() {
            const messagesRes = await getAllStudentMessages(this.student.student_id)
            this.studentMessages = messagesRes.data.reverse()
        },
        async getStudentBodyParameters() {
            this.studentsHeights = []
            this.studentsWeights = []
            const res = (await getStudentBodyParametersRequest(this.student.student_id)).data
            for(let i = 0; i < 12; i++) {
                res.find(item => new Date(item.date).getMonth() == i) ? this.studentsHeights.push(res.find(item => new Date(item.date).getMonth() == i).height) : this.studentsHeights.push(0)
                res.find(item => new Date(item.date).getMonth() == i) ? this.studentsWeights.push(res.find(item => new Date(item.date).getMonth() == i).weight) : this.studentsWeights.push(0)
            }            
        },
        async getStudentData() {
            const studentRes = await checkStudentAuthData(localStorage.studentLogin, localStorage.studentPassword)
            if (studentRes.data.status == 'error') {
                return false
            }
            this.student = studentRes.data.student

            return true
        },
        async getStudentCompletedTrainings() {
            const res = await getStudentCompletedTrainings(this.student.student_id)
            this.studentAttendedTrainings = res.data?.trainings_attended ?? []
            this.studentMissedTrainings = res.data?.missed_trainings ?? []
        },
        async getAllGroupStudents() {
            const studentsRes = await getStudentsByGroupId(this.student.group_id)
            this.groupStudents = studentsRes.data
        },
        async getGroupData() {
            if (this.student?.group_id) {
                const groupRes = await getGroupById(this.student.group_id)
                this.group = groupRes.data

                localStorage.setItem('group_payment', groupRes.data.payment_status)
            } else {
                this.group = {}
            }
            console.log('AAAAAAAAAAAAAAA - ', this.student)
        },
        async getTrainerData() {
            if (this.group?.trainer_id) {
                try {
                    const trainerRes = await getTrainerById(this.group?.trainer_id)
                    this.trainer = trainerRes.data
                } catch (e) {
                    this.trainer = {
                        name: '—',
                        surname: ''
                    }    
                }
            } else {
                this.trainer = {
                    name: '—',
                    surname: ''
                }
            }
        },
        async getPlanedTrainings() {
            if (this.student?.group_id) {
                const planedTrainingsRes = await getPlanedTrainingsByGroupId(this.group?.group_id)
                this.planedTrainingsData = planedTrainingsRes.data
            } else {
                this.planedTrainingsData = []
            }
        },
        async getStudentIncomes() {
            const incomesRes = await getIncomesByBalanceId(this.student.balance_id)
            this.studentIncomes = incomesRes.data.virtual_incomes
        },
        async getBalanceState() {
            const balanceStateRes = await getBalanceState(this.student.balance_id)
            this.studentBalance = balanceStateRes.data.balance_state
        },
        async updateUserPersonalDataAgreement() {
            await updateStudentPersonalDataAgreementsRequest(this.student.student_id)
            this.student.personal_data_agreement = true
        },
        async updateSchoolRulesAgreement() {
            await updateSchoolRulesAgreementsRequest(this.student.student_id)
            this.student.club_rules_agreement = true
        },
        async getTelegramBotSubscribed() {
            const res = await checkBotSubscribe(this.student.student_id)
            if(res.data.status == 'success') {
                this.isBotSubscribed = true
            } else {
                this.isBotSubscribed = false
            }
        }
    }
})